import React, { Component } from 'react';
import { validate } from '../../helpers/validator';
import Input from './Input';

/* eslint-disable no-extend-native */
String.prototype.ucFirst = function() {
  return this[0].toUpperCase() + this.substr(1).toLowerCase();
};
/* eslint-enable no-extend-native */

class Field extends Component {

  constructor() {
    super();

    this.state = {
      error: null
    };

    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  static propTypes = {
    required: React.PropTypes.bool,
    form: React.PropTypes.object.isRequired,
    input: React.PropTypes.object.isRequired,
    index: React.PropTypes.number.isRequired
  };

  blur(e) {
    this.validate(e);
  }

  focus(e) {
    const { form } = this.props;
    // Clear form and field errors
    this.setState({ error: null });
    form.setState({ error: null });
  }

  onChange(e) {
    const { form, index } = this.props;
    const { fields } = form.state;
    // Update form state with value
    fields[index].value = e.target.value;
    form.setState({ fields });
  }

  validate(e) {
    const { value } = e.target;
    const { required, input, form, index } = this.props;
    const { fields } = form.state;
    const { type, name } = input;
    let error = null;

    // Check if required
    if (required && !value.length) {
      error = `${name.ucFirst()} is required.`;
    }

    // Check type validation
    const isValid = validate(value, type);
    if (!error && !isValid) {
      error = `Please enter a valid ${name}.`
    }

    // Update field state with error
    this.setState({ error });

    // Update form state with error
    fields[index].error = error;
    form.setState({ fields });
  }

  render() {
    const { grid, input } = this.props;
    return (
      <fieldset className={grid}>
        <Input {...input} onFocus={this.focus} onBlur={this.blur} onChange={this.onChange} />
        { this.state.error ? <p className="error">{this.state.error}</p> : null }
      </fieldset>
    );
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/components/Form/Field.js